import CreateAccountToast from './CreateAccountToast';

export default CreateAccountToast;
